/**
 * TanStack Query hooks for `new-fallback-redirect-attribution`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	newFallbackRedirectAttributionQueryKeys,
	type CreateNewFallbackRedirectAttributionBody,
	type ListNewFallbackRedirectAttributionResponse,
	type NewFallbackRedirectAttributionRow,
} from "./api";

export function useNewFallbackRedirectAttributionList(): UseQueryResult<ListNewFallbackRedirectAttributionResponse, Error> {
	return useQuery({
		queryKey: newFallbackRedirectAttributionQueryKeys.list(),
		queryFn: list,
	});
}

export function useNewFallbackRedirectAttributionCreate(): UseMutationResult<NewFallbackRedirectAttributionRow, Error, CreateNewFallbackRedirectAttributionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: newFallbackRedirectAttributionQueryKeys.all });
		},
	});
}

export function useNewFallbackRedirectAttributionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: newFallbackRedirectAttributionQueryKeys.all });
		},
	});
}
